import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { SEO } from '../components/SEO';
import { ShieldIcon, TrendingUpIcon, UsersIcon, ArrowRightIcon, CalendarIcon, UserIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
export const OverOnsPage: React.FC = () => {
  const navigate = useNavigate();
  const teamMembers = [{
    name: 'Rocco',
    role: 'Oprichter & Strateeg',
    slug: 'rocco',
    bio: 'Oprichter van Noord Digital en bedenker van CorePrint. Gelooft dat elke groeibeslissing onderbouwd moet worden met data.',
    image: 'https://cdn.magicpatterns.com/uploads/6NEVZ9gbtbKb9LzgRcu9P4/image.png',
    objectPosition: 'center 60%'
  }, {
    name: 'Beer',
    role: 'SEO Specialist',
    slug: 'beer',
    bio: 'Specialist in organische groei voor B2B-bedrijven. Bouwt SEO-structuren die converteren, niet alleen ranken.',
    image: 'https://cdn.magicpatterns.com/uploads/3h5jPU9M1S7oTcbxfUFYhr/image.png',
    objectPosition: 'center 60%'
  }, {
    name: 'Alex',
    role: 'Developer',
    slug: 'alex',
    bio: 'Vertaalt strategie naar snelle, gebruiksvriendelijke websites die passen bij de merkidentiteit van de klant.',
    image: 'https://cdn.magicpatterns.com/uploads/gwFh8VhGW156sUNRdzC2Ac/image.png',
    objectPosition: 'center 60%'
  }, {
    name: 'Jelle Zwaanenburg',
    role: 'Sales Executive',
    slug: 'jelle',
    bio: 'Draait de sales voor Noord Digital. Zorgt voor het eerste contact en vertaalt jouw groeivraag naar een passend voorstel.',
    image: 'https://cdn.magicpatterns.com/uploads/5AvkpigfrYsv7QATg1Cgrc/WhatsApp_Image_2026-05-09_at_11.41.56.jpg',
    objectPosition: 'center 20%'
  }, {
    name: 'Loïs Bruins',
    role: 'Junior Vormgever',
    slug: 'lois',
    bio: 'Maakt designs voor Noord Digital. Vertaalt strategie en merk naar visueel werk dat klopt en converteert.',
    image: 'https://cdn.magicpatterns.com/uploads/24tAJ2MdsgDjmhw3y14fYd/Norden_Lois.png',
    objectPosition: 'center 30%'
  }, {
    name: 'Jesse Put',
    role: 'Junior Sales Executive',
    slug: 'jesse',
    bio: 'Loopt stage bij Noord Digital om de fijne kneepjes van het sales-vak te leren van Rocco en Jelle. Frisse blik, scherpe vragen.',
    image: 'https://cdn.magicpatterns.com/uploads/8MJF64emYA1SRDFsWSY2N8/Norden_Jesse_put.png',
    objectPosition: 'center 30%'
  }, {
    name: 'Norden',
    role: 'Ads & Data Specialist',
    slug: 'norden',
    bio: 'Beheert de Google Ads-campagnes van CorePrint en zorgt dat elke euro advertentiebudget data oplevert.',
    image: 'https://cdn.magicpatterns.com/uploads/fv5nFyNt1SPvWUkxd2YKYJ/Norden_portret_300dpi_2.png',
    objectPosition: 'center 50%'
  }];
  return <div className="min-h-screen bg-white font-sans text-[#111827]" data-id="element-1432">
      <SEO data-id="element-1433" />
      <Header data-id="element-1434" />

      {/* Section 1 — Hero */}
      <section className="pt-32 pb-20 lg:pt-40 lg:pb-24 bg-gradient-to-b from-[#FFFFFF] to-[#EEF5FA]" data-id="element-1435">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1436">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20" data-id="element-1437">
            <div className="lg:w-1/2" data-id="element-1438">
              <motion.h1 initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-[#111827] leading-tight mb-6" data-id="element-1439">
                Het team achter Noord Digital
              </motion.h1>
              <motion.p initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.1
            }} className="text-lg md:text-xl text-[#4B5563] leading-relaxed mb-8" data-id="element-1440">
                Wij zijn een klein, gedreven team van specialisten die geloven
                dat online groei begint met bewijs en niet met aannames.
              </motion.p>
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.2
            }} data-id="element-1441">
                <a href="#team" className="inline-flex items-center gap-2 px-6 py-3 bg-[#004AC7] text-white font-semibold rounded-lg hover:bg-[#003A9E] transition-colors shadow-md" data-id="element-1442">
                  Ontmoet het team <ArrowRightIcon className="w-5 h-5" data-id="element-1443" />
                </a>
              </motion.div>
            </div>
            <div className="lg:w-1/2 w-full" data-id="element-1444">
              <motion.div initial={{
              opacity: 0,
              scale: 0.95
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              delay: 0.2,
              duration: 0.5
            }} className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]" data-id="element-1445">
                <img src="https://cdn.magicpatterns.com/uploads/au6CUb9MtiVsZo5hShj5nJ/IMG_2983.jpg" alt="Het team van Noord Digital voor het kantoor met het Noord-bord" className="w-full h-full object-cover" data-id="element-1446" />
                <div className="absolute inset-0 bg-gradient-to-tr from-[#004AC7]/15 to-transparent mix-blend-multiply" data-id="element-1447"></div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Section 2 — Onze missie */}
      <section className="py-24 bg-white" data-id="element-1448">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1449">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1450">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#111827]" data-id="element-1451">
              Waarom Noord Digital?
            </h2>
            <p className="text-[#4B5563] text-lg leading-relaxed mb-4" data-id="element-1452">
              Bij Noord Digital geloven we in eerlijkheid over wat werkt. Geen
              loze beloftes of vage marketingtermen, maar een heldere aanpak
              gebaseerd op data en bewezen strategieën.
            </p>
            <p className="text-[#4B5563] text-lg leading-relaxed" data-id="element-1453">
              We gaan voor lange termijn partnerships. Jouw succes is ons
              succes. Daarom werken we nauw met je samen, als een verlengstuk
              van je eigen team.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-1454">
            <motion.div whileHover={{
            y: -5
          }} className="bg-[#F7F8FA] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-1455">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center text-[#004AC7] mb-6 shadow-sm" data-id="element-1456">
                <ShieldIcon className="w-7 h-7" data-id="element-1457" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#111827]" data-id="element-1458">
                Geen verborgen kosten
              </h3>
              <p className="text-[#4B5563] leading-relaxed" data-id="element-1459">
                We zijn transparant in onze werkwijze en prijzen. Je weet altijd
                precies waar je aan toe bent, zonder verrassingen achteraf.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-[#F7F8FA] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-1460">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center text-[#004AC7] mb-6 shadow-sm" data-id="element-1461">
                <TrendingUpIcon className="w-7 h-7" data-id="element-1462" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#111827]" data-id="element-1463">
                Data-gedreven groei
              </h3>
              <p className="text-[#4B5563] leading-relaxed" data-id="element-1464">
                We meten alles, analyseren de resultaten en sturen bij waar
                nodig voor maximaal rendement. Aannames laten we aan anderen
                over.
              </p>
            </motion.div>

            <motion.div whileHover={{
            y: -5
          }} className="bg-[#F7F8FA] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-1465">
              <div className="bg-white w-14 h-14 rounded-xl flex items-center justify-center text-[#004AC7] mb-6 shadow-sm" data-id="element-1466">
                <UsersIcon className="w-7 h-7" data-id="element-1467" />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#111827]" data-id="element-1468">
                Persoonlijk contact
              </h3>
              <p className="text-[#4B5563] leading-relaxed" data-id="element-1469">
                Korte lijntjes en snelle communicatie met één dedicated
                contactpersoon die jouw bedrijf en markt door en door kent.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Section 3 — Team grid */}
      <section id="team" className="py-24 bg-[#F7F8FA]" data-id="element-1470">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1471">
          <div className="text-center mb-16" data-id="element-1472">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#111827]" data-id="element-1473">
              Maak kennis met ons team
            </h2>
            <p className="text-lg text-[#4B5563]" data-id="element-1474">
              De specialisten die bouwen aan jouw online succes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1475">
            {teamMembers.map((member, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            y: -8
          }} className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full group cursor-pointer border border-gray-100" onClick={() => navigate(`/over-ons/${member.slug}`)} data-id="element-1476">
                <div className="relative h-64 w-full overflow-hidden bg-[#EEF5FA]" data-id="element-1477">
                  {member.image ? <img src={member.image} alt={member.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" style={{
                objectPosition: member.objectPosition
              }} data-id="element-1478" /> : <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-[#EEF5FA] to-[#DCE9F5]" data-id="element-1479">
                      <div className="w-28 h-28 rounded-full bg-white/80 border-4 border-white shadow-inner flex items-center justify-center" data-id="element-1480">
                        <UserIcon className="w-14 h-14 text-[#9CA3AF]" strokeWidth={1.5} data-id="element-1481" />
                      </div>
                    </div>}
                </div>
                <div className="p-6 flex-grow flex flex-col" data-id="element-1482">
                  <h3 className="text-xl font-bold text-[#111827] mb-1 group-hover:text-[#004AC7] transition-colors" data-id="element-1483">
                    {member.name}
                  </h3>
                  <p className="text-sm font-semibold text-[#004AC7] mb-4 uppercase tracking-wide" data-id="element-1484">
                    {member.role}
                  </p>
                  <p className="text-[#4B5563] text-sm leading-relaxed mb-6 flex-grow" data-id="element-1485">
                    {member.bio}
                  </p>
                  <div className="text-[#111827] font-semibold flex items-center gap-2 group-hover:text-[#004AC7] transition-colors mt-auto" data-id="element-1486">
                    Bekijk profiel{' '}
                    <ArrowRightIcon className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-1487" />
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Section 4 — Personal Contact CTA */}
      <section className="py-24 bg-white overflow-hidden" data-id="element-1488">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1489">
          <div className="bg-[#004AC7] rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-1490">
            {/* Decorative background elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-1491"></div>
            <div className="absolute bottom-0 left-0 w-80 h-80 bg-[#002A7A] opacity-50 rounded-full blur-3xl -ml-20 -mb-20" data-id="element-1492"></div>

            <div className="flex flex-col md:flex-row items-center relative z-10" data-id="element-1493">
              <div className="md:w-1/2 p-10 md:p-16 lg:p-20 flex flex-col justify-center" data-id="element-1494">
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-1495">
                  Benieuwd wat we voor jou kunnen betekenen?
                </h2>
                <p className="text-xl text-white/90 mb-10 leading-relaxed" data-id="element-1496">
                  Geen gladde verkooppraatjes, maar een eerlijk gesprek over
                  jouw groeikansen. Plan een kennismaking met Rocco.
                </p>
                <div className="flex flex-col sm:flex-row gap-4" data-id="element-1497">
                  <a href="/#contact" className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#004AC7] font-bold rounded-xl hover:bg-gray-50 transition-colors duration-300 shadow-lg text-lg" data-id="element-1498">
                    <CalendarIcon className="w-5 h-5" data-id="element-1499" /> Plan een kennismaking
                  </a>
                </div>
              </div>
              <div className="md:w-1/2 w-full h-full min-h-[400px] relative" data-id="element-1500">
                <img src="https://cdn.magicpatterns.com/uploads/bHpW8bmTGE8GfDnPuTgcdC/image.png" alt="Rocco van Noord Digital" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-1501" />
                {/* Gradient overlay to blend image with background on mobile */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#004AC7] to-transparent md:bg-gradient-to-r md:from-[#004AC7] md:to-transparent w-full h-full opacity-60 md:opacity-100 md:w-1/3" data-id="element-1502"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-1503" />
    </div>;
};